import { environment } from 'src/environments/environment';

export class Config {
    public url_base = environment.urlBase;
    public redirect_uri = environment.publicPath;
    public client_id = "B3WAY_CLIENT";
    public response_type = "code";
    public grant_type = "authorization_code";
    public policy = "?????";
}

